import React, { useEffect, useState, RefObject } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Pagination, Select, Input } from "components";
import { WindowIcon } from "icons";
import { generateDynamicRecords, uuid, isCompanyAccount } from "utils";

import { GetStudentList } from "models/messagemanagement/getStudentList";
import {
  // selectIsLoading,
  getStudentListSuccessResponse,
} from "redux/messagemanagement/getstudentlist/getStudentListStates";
import { IOption } from "components/select/Select";
import {
  GetStudentActionCreators,
  GetDataStatisticsActionCreators,
} from "redux/rootActions";
import {
  dataStatisticsResponse,
  selectIsLoading,
} from "redux/bodyTemperature/statistics/statisticsStates";
import {
  WrapperTable,
  TopTable,
  WrapperTextLinkBold,
  TextLinkBold,
  SendMessageBtn,
  ContentTable,
  WrapperTextLink,
  TextLink,
  TableStyled,
  WrapperSizeChange,
  WrapperPagination,
  WrapperActionTable,
  Message,
  WrapperMessage,
  NoDataMessage,
  WrapperActionSection,
  WrapperPaginationBottom,
} from "./MessageDelivery.style";
import { FormStatus } from "./MessageDelivery";

type RowSelection = {
  selectedRowKeys: string[] | number[];
  onSelect: any;
  onSelectAll: any;
};
interface IStudentList {
  columns: any;
  showModal: (formStatus: FormStatus) => void;
  rowSelection?: RowSelection;
  selectedRows: GetStudentList[];
  onPageChange: any;
  onPerPageItemChange: any;
  setSelectedRows: any;
  handleSelectCurrentPage: any;
  handleDeselectAllRecords: any;
  filterActions: any;
  setFilterActions: any;
  isSelectCurrentPage: boolean;
  isSelectAll: boolean;
  currentPageData: any;
  total: number;
  scrollAbleRef: RefObject<any>;
}

const StudentList: React.FC<IStudentList> = (props) => {
  const {
    columns,
    showModal,
    rowSelection,
    selectedRows,
    onPageChange,
    onPerPageItemChange,
    setSelectedRows,
    handleSelectCurrentPage,
    handleDeselectAllRecords,
    filterActions,
    setFilterActions,
    isSelectCurrentPage,
    isSelectAll,
    currentPageData,
    total,
    scrollAbleRef,
  } = props;
  const { t }: any = useTranslation("translation", {
    keyPrefix: "message-delivery",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "common",
  });

  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const studentListDataResponse = useSelector(getStudentListSuccessResponse);

  const [debouncedValue, setDebouncedValue] = useState<any>("");
  const [recordOptions, setRecordOptions] = useState<IOption[]>([]);
  const [firstRender, setFirstRender] = useState("1");

  const handleDeselectAll = () => {
    handleDeselectAllRecords();
    setSelectedRows([]);
  };

  const handleOnChangeName = (e: any) => {
    setFilterActions((prevState: any) => ({
      ...prevState,
      page: 1,
      patient_name: e.target.value,
    }));
    setFirstRender(uuid());
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(filterActions.patient_name || "");
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [filterActions.patient_name]);

  useEffect(() => {
    if (firstRender !== "1") {
      // dispatch(GetStudentActionCreators.getStudentListAction(filterActions));
      dispatch(
        GetDataStatisticsActionCreators.getStatisticsAction(filterActions)
      );
    }
  }, [debouncedValue]);

  useEffect(() => {
    let recordOptionsClone: IOption[] = [];
    recordOptionsClone = generateDynamicRecords(total, t1);
    setRecordOptions([...recordOptionsClone]);
  }, [total, t1]);

  const ShowPagination = () => {
    return (
      <WrapperPagination>
        <Pagination
          current={filterActions.page}
          onChange={onPageChange}
          pageSize={filterActions.per_page}
          total={total}
          showSizeChanger={false}
        />
      </WrapperPagination>
    );
  };

  const SubSection = () => {
    if (!selectedRows.length) return <></>;
    if (isSelectCurrentPage) {
      return (
        <WrapperMessage>
          <Message>
            <div
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              <Trans
                i18nKey="message-delivery.all-selected-message"
                count={selectedRows.length || 0}
              >
                このページのユーザー
                <strong>{selectedRows.length || 0}</strong>
                件が選択されています。
              </Trans>
            </div>
            <a onClick={handleDeselectAll}>{t("deselect")}</a>
          </Message>
        </WrapperMessage>
      );
    }

    return (
      <WrapperMessage>
        <Message>
          <div
            style={{
              whiteSpace: "pre-wrap",
            }}
          >
            <Trans
              i18nKey="message-delivery.selected-user"
              count={selectedRows.length || 0}
            >
              <strong>{selectedRows.length || 0}</strong>
              件のユーザーが選択されています。
            </Trans>
          </div>
          {(!isSelectAll || total > 50) && (
            <a onClick={handleSelectCurrentPage}>
              <Trans
                i18nKey="message-delivery.users-on-a-page"
                count={currentPageData.length || 0}
              >
                このページの
                <strong>{currentPageData.length || 0}</strong>
                件のユーザーのみを選択
              </Trans>
            </a>
          )}
        </Message>
      </WrapperMessage>
    );
  };

  return (
    <WrapperTable>
      <TopTable>
        <WrapperTextLinkBold>
          <TextLinkBold onClick={() => showModal("searchCondition")}>
            {t("search-condition")}
          </TextLinkBold>
          <WindowIcon fill="#3B3B3B" />
        </WrapperTextLinkBold>
        <SendMessageBtn
          background="#2AC769"
          color="#fff"
          name={t("message-composition")}
          border="none"
          fontWeight={700}
          fontSize={16}
          bdr="6px"
          onClick={() => showModal("sendMessage")}
          disabled={!selectedRows.length}
        />
      </TopTable>
      <ContentTable>
        <div
          style={{
            display: "flex",
            lineHeight: "18px",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <div style={{ fontSize: 18, color: "#3B3B3B" }}>
            {t("search-applicable")}
            <span style={{ fontWeight: 700 }}>{total || 0}</span>
            {t("people")}
          </div>
          <WrapperTextLink>
            <Link to="message-delivery/history">
              <TextLink>{t("message-history")}</TextLink>
            </Link>
            <WindowIcon fill="#3B3B3B" />
          </WrapperTextLink>
        </div>
        <WrapperActionSection>
          <span style={{ paddingTop: 5, fontSize: 16 }}>
            {isCompanyAccount()
              ? t2("employee-number-search")
              : t("search-by-name")}
          </span>
          <Input
            height={28}
            value={filterActions?.patient_name}
            onChange={handleOnChangeName}
          />
        </WrapperActionSection>
        <WrapperActionTable>
          <WrapperSizeChange>
            <div style={{ fontWeight: 500, fontSize: 14, marginRight: 5 }}>
              {t1("record")}
            </div>
            <Select
              defaultValue={50}
              options={recordOptions}
              onChange={onPerPageItemChange}
            />
          </WrapperSizeChange>
          {total > filterActions.per_page && <ShowPagination />}
        </WrapperActionTable>
        <SubSection />
        <div style={{ minHeight: 900 }} ref={scrollAbleRef}>
          <TableStyled
            rowSelection={rowSelection}
            columns={columns}
            dataSource={currentPageData}
            scroll={total > 0 ? { x: "max-content" } : {}}
            loading={isLoading}
          />
          {!currentPageData.length && (
            <>
              {studentListDataResponse ? (
                <NoDataMessage>{t("no-search-condition")}</NoDataMessage>
              ) : (
                <NoDataMessage>{t("no-data-message")}</NoDataMessage>
              )}
            </>
          )}
        </div>
        {total > filterActions.per_page && (
          <WrapperPaginationBottom>
            <ShowPagination />
          </WrapperPaginationBottom>
        )}
      </ContentTable>
    </WrapperTable>
  );
};

export default StudentList;
